export default "__VITE_ASSET__CHcLYZTW__"